import React, { useEffect, useMemo, useState } from 'react'
import $ from 'jquery'
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2'
import { getCompany, getOutletId, isOnline, logOutCompany } from '../../../helpers/commonFunctions';
import { GetBrandOutletsList, GetBrandAndOutletList } from '../../../services/company_panel/outletService';
import { GetBrandsHavingOutlets } from '../../../services/company_panel/brandService';
import { Dropdown } from 'semantic-ui-react';
import { getAllBrandWithOutlets, getBrandWithOutlets, saveBrandWithOutlets } from '../../../helpers/indexedDB';


const Header = ({ updateHeader = null }) => {
	const [userData, setUserData] = useState({});
	const [outletList, setOutletList] = useState([]);
	const [brandList, setBrandList] = useState([]);
	const [isBrandChanged, setIsBrandChanged] = useState(false);
	const [isOutletListModified, setIsOutletListModified] = useState(false);
	const [isBrandListModified, setIsBrandListModified] = useState(false);

	const [brandId, setBrandId] = useState(JSON.parse(localStorage.getItem('brand_id')));
	const [outletId, setOutletId] = useState(JSON.parse(localStorage.getItem('outlet_id')));

	const handleReload = () => {
		window.location.reload();
	};

	useEffect(() => {

		if(isOnline()){
			GetBrandsHavingOutlets(getCompany().company_id).then(data => {
				const allBrands = data && data.data && data.data.response ? data.data.response : [];
				const brandDropdown = allBrands.map((res) => ({
					key: res.id,
					text: res.name.charAt(0).toUpperCase() + res.name.slice(1),
					value: res.id,
				}))
				setBrandList(brandDropdown);
				if (allBrands.length) {
					const selectedBrandId = localStorage.getItem('brand_id');
					if (selectedBrandId) {
						const selectedBrand = allBrands.filter(item => item.id === Number(selectedBrandId))[0];
						if (selectedBrand) {
							setBrandId(Number(selectedBrandId));
						} else {
							setBrandId(allBrands[0].id);
							localStorage.setItem('brand_id', allBrands[0].id);
						}
					} else {
						setBrandId(allBrands[0].id);
						localStorage.setItem('brand_id', allBrands[0].id);
					}
				}
			}).catch(error => {
				console.log("brand with outlets error=====>", error)
			})
		}

	}, [isBrandListModified])

	useEffect(() => {
		if(isOnline()){
			GetBrandOutletsList({ brand_ids: JSON.stringify([JSON.parse(localStorage.getItem('brand_id'))]) }).then(data => {
				const allOutlet = data && data.data && data.data.response ? data.data.response : []
				const outletDropdown = allOutlet.map((res) => ({
					key: res.id,
					text: `${res.outlet_name.charAt(0).toUpperCase() + res.outlet_name.slice(1)}${res.short_code ? ` (${res.short_code})` : ''}`,
					value: res.id,
					business_date: res.business_date
				}))
				setOutletList(outletDropdown)
				if (allOutlet.length) {
					const selectedId = getOutletId();
					let newOutletId;
					if (selectedId) {
						const selectedOutlet = allOutlet.filter(item => item.id === Number(selectedId))[0];
						if (selectedOutlet) {
							newOutletId = Number(selectedId);
							setOutletId(newOutletId);
							localStorage.setItem('outlet_business_date', selectedOutlet.business_date);
						} else {
							newOutletId = allOutlet[0].id;
							setOutletId(newOutletId);
							localStorage.setItem('outlet_id', newOutletId);
							localStorage.setItem('outlet_business_date', allOutlet[0].business_date);
						}
					} else {
						newOutletId = allOutlet[0].id;
						setOutletId(newOutletId);
						localStorage.setItem('outlet_id', newOutletId);
						localStorage.setItem('outlet_business_date', allOutlet[0].business_date);
					}
					const evt = new CustomEvent('brand-changed', { detail: { outlet_id : newOutletId  }});
					document.dispatchEvent(evt);

					const evt2 = new CustomEvent('outlet-changed', { detail: { outlet_id: newOutletId } });
					document.dispatchEvent(evt2);
				}

			}).catch(error => {
				console.log("error=====>", error)
			})
		}

	}, [isBrandChanged, isOutletListModified]);


	const logout = () => {
		Swal.fire({
			customClass: 'swal-wide',
			title: 'Are you sure?',
			text: "You want to logout!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#2f9bff',
			cancelButtonColor: '#dc3545',
			confirmButtonText: 'Yes'
		}).then((result) => {
			if (result.isConfirmed) {
				logOutCompany();
			}
		})

	}
	useEffect(() => {
		setUserData(getCompany());
	}, [updateHeader])



	const toggleSidebar = (e) => {
		e.preventDefault();
		if ($("body").hasClass("main-sidebar-hide")) {
			$("body").removeClass("main-sidebar-hide")
		} else {
			$("body").addClass("main-sidebar-hide")
		}
	}

	$(document).ready(function () {
		$('.showpop').click(function () {
			$('.main-profile-menu').addClass("show");
		})
		$('.fixed_bg').click(function () {
			$('.main-profile-menu').removeClass("show");
		})
	});

	function handleChangeBrand(data) {
		setBrandId(data);
		localStorage.setItem('brand_id', data);
		setTimeout(() => {
			setIsBrandChanged(!isBrandChanged);
		}, 100)
	}
	function handleChangeOutlet(data) {
		setOutletId(data);
		localStorage.setItem('outlet_id', data);
		
		const outlet = outletList.find(outlet => outlet.value == data);
		localStorage.setItem('outlet_business_date', outlet.business_date);

		setTimeout(() => {
			const evt = new CustomEvent('outlet-changed', { detail: { outlet_id: data } });
			document.dispatchEvent(evt);
		}, 100)
	}

	useMemo(() => {
		document.addEventListener('outlet-list-modified', function () {
			setIsOutletListModified(!isOutletListModified);
		});
	});

	useMemo(() => {
		document.addEventListener('brand-list-modified', function () {
			setIsBrandListModified(!isBrandListModified);
		});
	});

	return (
		<>
			{/* <!-- Main Header--> */}
			<header className="justify-content-between d-flex align-items-center">
				<div className="header-in d-flex w-100 justify-content-between align-items-center">
					<div className="header-search">
						{/* <input className="form-control" type="text" placeholder="Default input" aria-label="default input example"> */}
					</div>
					<div className="header-right">
						<ul className="header-right-menu d-flex gap-2 m-0">
							<li>
								<div className='form-group header-drop'>
									<Dropdown
										className='form-control'
										id="brand_id"
										placeholder='Select Brand'
										search
										fluid
										selection
										options={brandList}
										value={brandId}
										onChange={(event, data) => { handleChangeBrand(data.value); }}
									/>
								</div>
							</li>
							<li>
								<div className='form-group header-drop'>
									<Dropdown
										className='form-control'
										id="outlet_id"
										placeholder='Select Outlet'
										search
										fluid
										selection
										options={outletList}
										value={outletId}
										onChange={(event, data) => { handleChangeOutlet(data.value); }}
									// onChange={(event, data) => { localStorage.setItem('outlet_id', data.value); setOutletId(data.value); handleReload(); }}
									/>
								</div>
							</li>
							<li>
								<div className="dropdown">
									<button className="btn p-0 d-flex align-items-center dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
										<div className='avatar'>
											<img alt="avatar" src={userData.profile_image} />
										</div>
									</button>
									<ul className="dropdown-menu">
										<li><Link className="dropdown-item " to={"/company/profile"}><i className="ti ti-user"></i> My Profile</Link></li>
										<li><Link className="dropdown-item " to={"/company/company-profile"}><i className="ti ti-building-skyscraper"></i> Company Profile</Link></li>
										<li><button className="dropdown-item " onClick={() => logout()}><i className="ti ti-logout"></i> Log Out</button></li>
									</ul>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</header>
			
			{/* <!-- End Main Header--> */}
		</>
	)
}

export default Header;